import React from 'react';
import { useTranslation } from 'react-i18next';
import './LanguageSwitcher.scss';

interface LanguageSwitcherProps {
  className?: string;
}

const LanguageSwitcher: React.FC<LanguageSwitcherProps> = ({ className = '' }) => {
  const { i18n, t } = useTranslation();

  // Mapeo de códigos de idioma a emojis de banderas
  const flagMap: Record<string, string> = {
    'en': '🇺🇸',
    'es': '🇪🇸',
    'fr': '🇫🇷',
    'pt': '🇧🇷',
  };

  const languages = [
    { code: 'es', name: t('languages.es') },
    { code: 'en', name: t('languages.en') },
    { code: 'fr', name: t('languages.fr') },
    { code: 'pt', name: t('languages.pt') },
  ];

  const handleLanguageChange = (event: React.ChangeEvent<HTMLSelectElement>) => {
    const newLang = event.target.value;
    i18n.changeLanguage(newLang);
  };

  return (
    <div className={`language-switcher ${className}`}>
      <select
        value={i18n.language}
        onChange={handleLanguageChange}
        className="language-switcher__select"
        aria-label={t('navigation.language')}
      >
        {languages.map((lang) => (
          <option key={lang.code} value={lang.code}>
            {flagMap[lang.code]} {lang.name}
          </option>
        ))}
      </select>
    </div>
  );
};

export default LanguageSwitcher; 